import { BaseResponse } from 'domain/payload/response/BaseResponseDto';
import axiosInstance from '../../config/AxiosConfig'
import { ProjectFilterListResp } from 'domain/payload/response/clientTransmora/projectFilter/ProjectFilterListResp';
import { ProjectFilterDetailResp } from 'domain/payload/response/clientTransmora/projectFilter/ProjectFilterDetailResp';
import { ProjectFilterSaveReq } from 'domain/payload/request/clientTransmora/projectFilter/ProjectFilterSaveReq';

const ProjectFilterService = () => {
  const ProjectFilterList = async (
    token: string,
    search: string | null,
    page: number | null,
    size: number | null
  ): Promise<BaseResponse<ProjectFilterListResp[]>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-filter/list`, {
        headers: {
          Authorization: `Bearer ${token}`
        },
        params: {
          search: search,
          page: page,
          size: size
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectFilterDetail = async (
    token: string,
    id: string
  ): Promise<BaseResponse<ProjectFilterDetailResp>> => {
    try {
      const response = await axiosInstance.get(`/v1/legacy/cms/client-project-filter/detail?id=${id}`, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectFilterSave = async (
    token: string,
    payload: ProjectFilterSaveReq
  ): Promise<BaseResponse<ProjectFilterDetailResp>> => {
    try {
      const response = await axiosInstance.post(`/v1/legacy/cms/client-project-filter/save`, payload, {
        headers: {
          Authorization: `Bearer ${token}`
        }
      });

      return response.data

    } catch (error: any) {
      throw error.response.data.message;
    }
  };

  const ProjectFilterDelete = async (
    token: string,
    id: string
  ): Promise<BaseResponse<any>> => {
    try {
      const response = await axiosInstance.delete(
        `/v1/legacy/cms/client-project-filter/delete`,
        {
          headers: { Authorization: `Bearer ${token}` },
          params: { id },
        }
      );
      return response.data;
    } catch (error: any) {
      throw error.response?.data?.message || error.message;
    }
  };

  return { ProjectFilterList, ProjectFilterDetail, ProjectFilterSave, ProjectFilterDelete };
};

export default ProjectFilterService;